import { render, staticRenderFns } from "./CybermatR3.vue?vue&type=template&id=2f2bd293&scoped=true"
import script from "./CybermatR3.vue?vue&type=script&lang=ts"
export * from "./CybermatR3.vue?vue&type=script&lang=ts"
import style0 from "./CybermatR3.vue?vue&type=style&index=0&id=2f2bd293&prod&lang=scss&scoped=true"
import style1 from "./CybermatR3.vue?vue&type=style&index=1&id=2f2bd293&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2bd293",
  null
  
)

export default component.exports